const configDomain = 'https://www.intercartclothing.com';
const checkoutUrl = '/a/n/checkout/';

!(function (f, b, e, v, n, t, s) {
    if (f.fbq) return;
    n = f.fbq = function () {
        n.callMethod ?
            n.callMethod.apply(n, arguments) : n.queue.push(arguments)
    };
    if (!f._fbq) f._fbq = n;
    n.push = n;
    n.loaded = !0;
    n.version = '2.0';
    n.queue = [];
    t = b.createElement(e);
    t.async = !0;
    t.src = v;
    s = b.getElementsByTagName(e)[0];
    s.parentNode.insertBefore(t, s)
})(window, document, 'script', 'https://connect.facebook.net/en_US/fbevents.js');

!function (e) {
    if (!window.pintrk) {
        window.pintrk = function () {
            window.pintrk.queue.push(
                Array.prototype.slice.call(arguments))
        };
        var
            n = window.pintrk;
        n.queue = [], n.version = "3.0";
        var
            t = document.createElement("script");
        t.async = !0, t.src = e;
        var
            r = document.getElementsByTagName("script")[0];
        r.parentNode.insertBefore(t, r)
    }
}("https://s.pinimg.com/ct/core.js");

// TikTok Pixel
!function (w, d, t) {
    w.TiktokAnalyticsObject = t;
    var ttq = w[t] = w[t] || [];
    ttq.methods = ["page", "track", "identify", "instances", "debug", "on", "off", "once", "ready", "alias", "group", "enableCookie", "disableCookie", "holdConsent", "revokeConsent", "grantConsent"], ttq.setAndDefer = function (t, e) {
        t[e] = function () {
            t.push([e].concat(Array.prototype.slice.call(arguments, 0)))
        }
    };
    for (var i = 0; i < ttq.methods.length; i++) ttq.setAndDefer(ttq, ttq.methods[i]);
    ttq.instance = function (t) {
        for (
            var e = ttq._i[t] || [], n = 0; n < ttq.methods.length; n++) ttq.setAndDefer(e, ttq.methods[n]);
        return e
    }, ttq.load = function (e, n) {
        var r = "https://analytics.tiktok.com/i18n/pixel/events.js", o = n && n.partner;
        ttq._i = ttq._i || {}, ttq._i[e] = [], ttq._i[e]._u = r, ttq._t = ttq._t || {}, ttq._t[e] = +new Date, ttq._o = ttq._o || {}, ttq._o[e] = n || {};
        n = document.createElement("script")
        ;n.type = "text/javascript", n.async = !0, n.src = r + "?sdkid=" + e + "&lib=" + t;
        e = document.getElementsByTagName("script")[0];
        e.parentNode.insertBefore(n, e)
    };
}(window, document, 'ttq');

(async function () {
    // 判断window.Shopify为空直接返回
    if (!window.Shopify) return;
    const current_shop_id = window.Shopify.shop.split('.')[0]
    const res = await fetch(`${configDomain}/api/shopify/configs/${current_shop_id}?configs=pixel`);
    const data = await res.json();

    // 保存 pixel 配置到 localStorage
    const pixelConfigs = {
        facebook: [],
        pinterest: [],
        tiktok: []
    };

    data.pixel_configs.forEach(p => {
        if (p.channel === 'facebook') {
            pixelConfigs.facebook.push(p.pixel_id);
            fbq('init', p.pixel_id);
            console.log('fbq init', p.pixel_id);
        } else if (p.channel === 'pinterest') {
            pixelConfigs.pinterest.push(p.pixel_id);
            pintrk('load', p.pixel_id);
            console.log('pinterest init', p.pixel_id);
        } else if (p.channel === 'tiktok') {
            pixelConfigs.tiktok.push(p.pixel_id);
            ttq.load(p.pixel_id);
            console.log('tiktok init', p.pixel_id);
        }
    });

    // 保存配置到 localStorage
    localStorage.setItem('pixelConfigs', JSON.stringify(pixelConfigs));

    // 触发 PageView 事件
    if (pixelConfigs.facebook.length > 0) {
        fbq('track', 'PageView');
    }
    if (pixelConfigs.pinterest.length > 0) {
        pintrk('page');
    }
    if (pixelConfigs.tiktok.length > 0) {
        ttq.page();
    }
})();

function getPixelConfigs() {
    const configs = localStorage.getItem('pixelConfigs');
    return configs ? JSON.parse(configs) : {facebook: [], pinterest: [], tiktok: []};
}

const LoadingAnimation = function () {
    let t = null;
    return {
        show: function () {
            var e;
            (t = t || ((e = document.createElement("style")).innerHTML = `
            .loader-container {
                position: fixed;
                top: 0;
                left: 0;
                width: 100vw;
                height: 100%;
                display: flex;
                justify-content: center;
                align-items: center;
                background-color: rgba(255, 255, 255, 0);
                z-index: 9999;
                animation: fadeInBackground 3s forwards;
            }

            .custom-loader {
                width: 100px;
                height: 100px;
                border: 5px solid rgba(0, 0, 0, 0.1);
                border-radius: 50%;
                border-top-color: #0070ba;
                animation: spin 1s ease-in-out infinite;
                position: relative;
            }

            .spinnerImage {
                width: 50px;
                height: 50px;
                background: url("data:image/png;base64,UklGRnABAABXRUJQVlA4WAoAAAAQAAAAMQAAMQAAQUxQSPkAAAABgHNtmzFnFlVs2+nY2pVT2uyM1rbRmbublPwDtm3byRvPzBeWETEB6Ls0yhm6hqeVRk8uUzS6ACYbC2v6b2HRmRmOpw9FuuitWOgm5HEYYH+3boY+FudBOT2loy019FlOM/hRqwcL9Hmh2SMJSmpPTQjXFWIpRYMtFnt7kFLHGRcL1T0J0RkaR/iJYEhnaYBAABjRWSHh929n17O8snJ/vYJ/AFsrK8PJHAKmDwfdPN7kEA+/Z72bx5uAdAIpYIhosgbnCRSABBXEW/lnKjRnnDgUME7iD8dqdGIc/j9cDPhxaagvjRGQXQa6T14EkHhUXgHFZBP0lQEAVlA4IFAAAABwBQCdASoyADIAPrFCmEwnI6KiO+gA4BYJaQAAzFIU/21BJ4dSsxASuQcoDVJ87AtR8OBYAP7pnf/8Ce9/2aAf//gAXu38nRI/0tAAAAAAAA==") no-repeat center;
                background-size: contain;
                position: absolute;
                top: 50%;
                left: 50%;
                transform: translate(-50%, -50%);
            }

            @keyframes spin {
                to { transform: rotate(360deg); }
            }

            @keyframes fadeInBackground {
                0% {
                    background-color: rgba(255, 255, 255, 0); 
                }
                100% {
                    background-color: rgba(255, 255, 255, 1);
                }
            }
        `, document.head.appendChild(e), (e = document.createElement("div")).className = "loader-container", e.innerHTML = `
            <div class="custom-loader">&#8203;</div>
            <div class="spinnerImage">&#8203;</div>
        `, document.body.appendChild(e), e)).style.display = "flex", document.body.style.overflow = "hidden"
        }, hide: function () {
            t && (t.style.display = "none", document.body.style.overflow = "")
        }
    }
}()

function generateTimestampedUUID() {
    return (new Date).getTime() + "_" + "xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx".replace(/[xy]/g, function (e) {
        var t = 16 * Math.random() | 0;
        return ("x" === e ? t : 3 & t | 8).toString(16)
    })
}

function getCookie(e) {
    e = ("; " + document.cookie).split(`; ${e}=`);
    return 2 === e.length ? e.pop().split(";").shift() : ""
}

function toggleLoadingAnimation(e) {
    e ? LoadingAnimation.show() : setTimeout(function () {
        LoadingAnimation.hide()
    }, 5e3)
}


function getStoredFacebookAdsIds() {
    const n = JSON.parse(localStorage.getItem("easyTrack")) || {};
    return ["ad_id", "campaign_id", "adset_id"].reduce((e, t) => (e[t] = n[t] || "", e), {
        fbc: getCookie("_fbc"),
        fbp: getCookie("_fbp")
    })
}

function getOrCreateUserId() {
    var e = "myCartCustomerId";
    let t = localStorage.getItem(e);
    return t || (t = generateTimestampedUUID().split("_")[1], localStorage.setItem(e, t)), t
}

function getProductTitle() {
    // 优先使用 Shopify 内置数据
    if (window.ShopifyAnalytics?.meta?.product?.title) {
        return window.ShopifyAnalytics.meta.product.title;
    }

    // 尝试从 meta 标签获取
    var metaTitle = document.querySelector('meta[property="og:title"]');
    if (metaTitle) {
        return metaTitle.content;
    }

    // 从 DOM 获取
    var titleElement = document.querySelector('.product-title, h1.product__title, [itemprop="name"]');
    if (titleElement) {
        return titleElement.textContent.trim();
    }

    return null;
}


function setShopifyVariables() {
    return new Promise(e => {
        const t = () => {
            window.shopifyVariables = {
                shopId: window.Shopify.shop,
                clientId: getCookie("_shopify_y"),
                currency: window.Shopify.currency,
                country: window.Shopify.country
            };
            localStorage.setItem('shopifyVariables', JSON.stringify(window.shopifyVariables));
            e();
        };
        if (void 0 !== window.Shopify && window.Shopify.shop) t(); else {
            const n = new MutationObserver(() => {
                void 0 !== window.Shopify && window.Shopify.shop && (t(), n.disconnect())
            });
            n.observe(document, {childList: !0, subtree: !0})
        }
    })
}

async function my_product_checkout(e) {
    // console.log('Product checkout initiated:', productData)
    e && e.preventDefault();
    toggleLoadingAnimation(!0);

    try {
        // Get product information from the form
        const form = document.querySelector('form[data-type="add-to-cart-form"]');
        if (!form) {
            throw new Error('Product form not found');
        }

        // Get variant ID and quantity from the form
        const variantId = form.querySelector('input[name="id"]').value;
        const productId = form.querySelector('input[name="product-id"]').value;
        const quantityInput = form.querySelector('input[name="quantity"]');
        const variantPrice = form.querySelector('input[name="quantity"]').dataset.price / 100;
        const quantity = quantityInput ? parseInt(quantityInput.value) || 1 : 1;

        if (!variantId) {
            throw new Error('Product variant ID not found');
        }
        // Add product to cart
        const addResponse = await fetch('/cart/add.js', {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'X-Requested-With': 'XMLHttpRequest'
            },
            body: JSON.stringify({
                id: variantId,
                quantity: quantity
            })
        });

        if (!addResponse.ok) {
            const errorData = await addResponse.json();
            throw new Error(errorData.description || 'Failed to add product to cart');
        }

        const addResult = await addResponse.json();
        // Call my_checkout function to proceed with checkout
        await my_checkout();

        return addResult;

    } catch (error) {
        console.error('Error in product checkout process:', error);
        toggleLoadingAnimation(!1);
        throw error;
    }
}

async function my_checkout(e) {
    e && e.preventDefault();
    toggleLoadingAnimation(!0);

    try {
        // Set Shopify variables first
        await setShopifyVariables();
        // Fetch cart data
        const cartResponse = await fetch('/cart.json', {
            method: 'GET',
            headers: {'Content-Type': 'application/json'}
        });

        if (!cartResponse.ok) {
            throw new Error('network error');
        }

        const cartData = await cartResponse.json();
        const eventData = {
            content_ids: cartData.items.map(item => item.product_id),
            contents: cartData.items.map(item => ({
                product_id: item.product_id,
                title: item.title,
                quantity: item.quantity,
                item_price: item.price / 100
            })),
            num_items: cartData.item_count,
            value: cartData.total_price / 100,
            currency: window.shop_currency
        }

        const pixelConfigs = getPixelConfigs();

        // Facebook InitiateCheckout
        if (pixelConfigs.facebook.length > 0 && typeof fbq !== 'undefined') {
            fbq('track', 'InitiateCheckout', eventData);
        }

        // Pinterest InitiateCheckout
        if (pixelConfigs.pinterest.length > 0 && typeof pintrk !== 'undefined') {
            pintrk('track', 'initiatecheckout', {
                value: cartData.total_price / 100,
                order_quantity: cartData.item_count,
                currency: window.shop_currency,
                line_items: cartData.items.map(item => ({
                    product_id: item.product_id,
                    product_name: item.title,
                    product_price: item.price / 100,
                    product_quantity: item.quantity,
                    product_variant: item.variant_title,
                    product_variant_id: item.variant_id,

                }))
            });
        }

        // TikTok InitiateCheckout
        if (pixelConfigs.tiktok.length > 0 && typeof ttq !== 'undefined') {
            ttq.track('InitiateCheckout', {
                contents: cartData.items.map(item => ({
                    content_id: item.product_id,
                    content_type: 'product',
                    content_name: item.title,
                    quantity: item.quantity,
                    price: item.price / 100
                })),
                value: cartData.total_price / 100,
                currency: window.shop_currency
            });
        }

        const mergedData = {
            shopInfo: window.shopifyVariables,
            cartInfo: cartData,
            userId: getOrCreateUserId(),
            facebookInfo: getStoredFacebookAdsIds(),
            landing_page: window.location.href,
            timestamp: new Date().toISOString()
        };

        // console.log('InitiateCheckout', eventData);
        const apiResponse = await fetch(`${configDomain}/api/shopify/checkout`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json'
            },
            body: JSON.stringify(mergedData)
        });

        if (!apiResponse.ok) {
            throw new Error('API error');
        }
        const clearResponse = await fetch('/cart/clear.js', {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'X-Requested-With': 'XMLHttpRequest'
            }
        });

        if (!clearResponse.ok) {
            throw new Error('Failed to clear cart');
        }
        const apiResult = await apiResponse.json();
        // console.log('API response:', apiResult);
        if (apiResult.token) {
            window.location.href = `${checkoutUrl}${apiResult.token}`;
        } else {
            window.location.href = `/cart`;
        }
        // Handle successful API response here
        // For example, redirect to checkout or show success message
        return apiResult;

    } catch (error) {
        console.error('Error in checkout process:', error);
        // Handle error appropriately
        throw error; // Re-throw if you want calling code to handle it
    } finally {
        toggleLoadingAnimation(!1);
    }
}

function trackProductViewContent() {
    const productContainer = document.querySelector('.productView-container');

    if (!productContainer) {
        console.warn('.productView-container not found');
        return;
    }

    const observer = new IntersectionObserver((entries) => {
        entries.forEach(entry => {
            // 当元素进入视口且至少显示 50% 时触发
            if (entry.isIntersecting && entry.intersectionRatio >= 0.5) {
                const form = document.querySelector('form[data-type="add-to-cart-form"]');
                if (!form) {
                    console.warn('Product form not found');
                    return;
                }
                const productId = form.querySelector('input[name="product-id"]').value;
                const quantityInput = form.querySelector('input[name="quantity"]').value;
                const variantPrice = form.querySelector('input[name="quantity"]').dataset.price / 100;
                const productTitle = getProductTitle();

                const pixelConfigs = getPixelConfigs();

                // Facebook ViewContent
                if (pixelConfigs.facebook.length > 0 && typeof fbq !== 'undefined') {
                    const eventData = {
                        content_ids: [productId],
                        num_items: quantityInput,
                        contents: [
                            {
                                product_id: productId,
                                title: productTitle,
                                quantity: quantityInput,
                                price: variantPrice
                            }
                        ],
                        content_type: 'product',
                        value: variantPrice,
                        currency: window.shop_currency
                    }
                    fbq('track', 'ViewContent', eventData);
                    // console.log('ViewContent:', eventData)
                }

                // Pinterest ViewContent
                if (pixelConfigs.pinterest.length > 0 && typeof pintrk !== 'undefined') {
                    pintrk('track', 'pagevisit', {
                        product_id: productId,
                        product_name: productTitle,
                        product_price: variantPrice,
                        product_quantity: quantityInput,
                        currency: window.shop_currency
                    });
                }

                // TikTok ViewContent
                if (pixelConfigs.tiktok.length > 0 && typeof ttq !== 'undefined') {
                    ttq.track('ViewContent', {
                        content_id: productId,
                        content_type: 'product',
                        content_name: productTitle,
                        quantity: quantityInput,
                        price: variantPrice,
                        value: variantPrice,
                        currency: window.shop_currency
                    });
                }

                observer.unobserve(entry.target);
            }
        });
    }, {
        threshold: [0.5],
        rootMargin: '0px'
    });

    observer.observe(productContainer);
}

document.addEventListener('DOMContentLoaded', function () {
    setTimeout(trackProductViewContent, 1000);
});


const buttonIds = [
    'product-sticky-add-to-cart',
    'product-add-to-cart',
];

buttonIds.forEach(id => {
    const button = document.getElementById(id);
    if (button) {
        button.addEventListener('click', function () {
            if (this.getAttribute('data-tracked') !== 'true') {
                this.setAttribute('data-tracked', 'true');
                const form = document.querySelector('form[data-type="add-to-cart-form"]');
                if (!form) {
                    console.warn('Product form not found');
                    return;
                }
                const productId = form.querySelector('input[name="product-id"]').value;
                const quantityInput = form.querySelector('input[name="quantity"]').value;
                const variantPrice = form.querySelector('input[name="quantity"]').dataset.price / 100;
                const productTitle = getProductTitle();

                const pixelConfigs = getPixelConfigs();

                // Facebook AddToCart
                if (pixelConfigs.facebook.length > 0 && typeof fbq !== 'undefined') {
                    const eventData = {
                        content_ids: [productId],
                        num_items: quantityInput,
                        contents: [
                            {
                                product_id: productId,
                                title: productTitle,
                                quantity: quantityInput,
                                item_price: variantPrice
                            }
                        ],
                        content_type: 'product',
                        value: variantPrice,
                        currency: window.shop_currency,
                    }
                    fbq('track', 'AddToCart', eventData);
                }

                // Pinterest AddToCart
                if (pixelConfigs.pinterest.length > 0 && typeof pintrk !== 'undefined') {
                    pintrk('track', 'addtocart', {
                        value: variantPrice,
                        order_quantity: quantityInput,
                        currency: window.shop_currency,
                        product_id: productId,
                        product_name: productTitle
                    });
                }

                // TikTok AddToCart
                if (pixelConfigs.tiktok.length > 0 && typeof ttq !== 'undefined') {
                    ttq.track('AddToCart', {
                        content_id: productId,
                        content_type: 'product',
                        content_name: productTitle,
                        quantity: quantityInput,
                        price: variantPrice,
                        value: variantPrice,
                        currency: window.shop_currency
                    });
                }

                setTimeout(() => {
                    this.removeAttribute('data-tracked');
                }, 3000);
            }
        });
    }
});

async function checkoutWithVariant(variantId, quantity, upsellToken) {
    try {
        // Step 1: Clear cart
        const clearResponse = await fetch('/cart/clear.js', {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'X-Requested-With': 'XMLHttpRequest'
            }
        });

        if (!clearResponse.ok) {
            throw new Error('Failed to clear cart');
        }

        // Step 2: Add variant to cart
        const addResponse = await fetch('/cart/add.js', {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'X-Requested-With': 'XMLHttpRequest'
            },
            body: JSON.stringify({
                id: variantId,
                quantity: quantity
            })
        });

        if (!addResponse.ok) {
            const errorData = await addResponse.json();
            throw new Error(errorData.description || 'Failed to add variant to cart');
        }

        const cartResponse = await fetch('/cart.json', {
            method: 'GET',
            headers: {'Content-Type': 'application/json'}
        });

        if (!cartResponse.ok) {
            throw new Error('Failed to fetch cart data');
        }

        const cartData = await cartResponse.json();
        const shopifyVariables = JSON.parse(localStorage.getItem('shopifyVariables'));
        // Step 4: Submit to backend checkout API
        const mergedData = {
            shopInfo: shopifyVariables,
            cartInfo: cartData,
            userId: getOrCreateUserId(),
            facebookInfo: getStoredFacebookAdsIds(),
            upsell_token: upsellToken,
            landing_page: window.location.href,
            timestamp: new Date().toISOString()
        };

        const checkoutResponse = await fetch(`${configDomain}/api/shopify/checkout`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json'
            },
            body: JSON.stringify(mergedData)
        });

        if (!checkoutResponse.ok) {
            throw new Error('Checkout API request failed');
        }

        const checkoutResult = await checkoutResponse.json();

        if (!checkoutResult.token) {
            throw new Error('No token returned from checkout API');
        }
        return {
            success: true,
            token: checkoutResult.token,
            order_number: checkoutResult.order_number,
            cartInfo: cartData,
        };

    } catch (error) {
        console.error('Error in checkoutWithVariant:', error);
        return {
            success: false,
            error: error.message || 'Unknown error occurred'
        };
    }
}

/** 快捷支付 **/ 
!function(){
    
    if (!window.MutationObserver){
        // 浏览器不支持，IE10及以下不支持
        console.warn("该浏览器不支持 MutationObserver");
        return;
    }

    // 数据列表
    let merchants = [];

    // 获取商户数据
    async function getMerchantData() {
        const current_shop_id = window.Shopify.shop.split('.')[0]
        const res = await fetch(`${configDomain}/api/shopify/checkout/shop/${current_shop_id}`);
        const response = await res.json();
        if(response.code === 200){
            const result = response.data;
            return result ? atob(result) : undefined
        }
    }


    async function initQuickCheckout(){
        const data = await getMerchantData();
        if(!data) return;
        const resultData = JSON.parse(data);
        const is_quick_pay = resultData.shop_info.is_quick_pay;
        if(!is_quick_pay) return;
        merchants = resultData.merchants?.filter(item=>item.is_active && item.payment_method === "3party") || [];
        const el = document.getElementsByClassName("button-checkout-quick");
        for(let i = 0; i < el.length; i++ ){
            renderContent(el[i]);
        }
        const observer = new MutationObserver((mutations)=> {
            mutations.forEach((item)=>{
                if (item && item.addedNodes?.length) {
                    item.addedNodes?.forEach(() => {
                        const dom_list = document.querySelectorAll(".button-checkout-quick");
                        if(dom_list.length > 0){
                            for(let i=0; i<dom_list.length;i++){
                                renderContent(dom_list[i])
                            }
                        }
                    });
                }
            })
        });
        observer.observe(document.body, {
            childList: true,
            subtree: true
        });
    }

    initQuickCheckout()

    function renderStripeIcon(e){
        const width = e?.width || "8rem";
        const height = e?.height || "3rem";
        return `<svg width="60" height="25" viewBox="0 0 60 25" style="width: ${width}; height: ${height}; stroke:transparent;" xmlns="http://www.w3.org/2000/svg">
            <path fill="#ffffff" fill-rule="evenodd" d="M59.64 14.28h-8.06c.19 1.93 1.6 2.55 3.2 2.55 1.64 0 2.96-.37 4.05-.95v3.32a8.33 8.33 0 0 1-4.56 1.1c-4.01 0-6.83-2.5-6.83-7.48 0-4.19 2.39-7.52 6.3-7.52 3.92 0 5.96 3.28 5.96 7.5 0 .4-.04 1.26-.06 1.48zm-5.92-5.62c-1.03 0-2.17.73-2.17 2.58h4.25c0-1.85-1.07-2.58-2.08-2.58zM40.95 20.3c-1.44 0-2.32-.6-2.9-1.04l-.02 4.63-4.12.87V5.57h3.76l.08 1.02a4.7 4.7 0 0 1 3.23-1.29c2.9 0 5.62 2.6 5.62 7.4 0 5.23-2.7 7.6-5.65 7.6zM40 8.95c-.95 0-1.54.34-1.97.81l.02 6.12c.4.44.98.78 1.95.78 1.52 0 2.54-1.65 2.54-3.87 0-2.15-1.04-3.84-2.54-3.84zM28.24 5.57h4.13v14.44h-4.13V5.57zm0-4.7L32.37 0v3.36l-4.13.88V.88zm-4.32 9.35v9.79H19.8V5.57h3.7l.12 1.22c1-1.77 3.07-1.41 3.62-1.22v3.79c-.52-.17-2.29-.43-3.32.86zm-8.55 4.72c0 2.43 2.6 1.68 3.12 1.46v3.36c-.55.3-1.54.54-2.89.54a4.15 4.15 0 0 1-4.27-4.24l.01-13.17 4.02-.86v3.54h3.14V9.1h-3.13v5.85zm-4.91.7c0 2.97-2.31 4.66-5.73 4.66a11.2 11.2 0 0 1-4.46-.93v-3.93c1.38.75 3.1 1.31 4.46 1.31.92 0 1.53-.24 1.53-1C6.26 13.77 0 14.51 0 9.95 0 7.04 2.28 5.3 5.62 5.3c1.36 0 2.72.2 4.09.75v3.88a9.23 9.23 0 0 0-4.1-1.06c-.86 0-1.44.25-1.44.9 0 1.85 6.29.97 6.29 5.88z" ></path>
        </svg>`
    }
    function renderPaypalIcon(e){
        const width = e?.width || "12rem";
        const height = e?.height || "3rem";
        return `<svg viewBox="0 0 246 60" version="1.1" style="width: ${width}; height: ${height};" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
            <defs>
                <path id="path-1" d="M0.0363636364,60 L245.244848,60 L245.244848,0.497575758 L0.0363636364,0.497575758 L0.0363636364,60 L0.0363636364,60 Z"></path>
            </defs>
            <g id="Page-1" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
                <g id="pp_fc_hl">
                    <g id="pp_h_rgb">
                        <path d="M190.421818,26.4321212 C189.684848,31.2727273 185.987879,31.2727273 182.412121,31.2727273 L180.377576,31.2727273 L181.804848,22.2351515 C181.890909,21.6890909 182.361818,21.2866667 182.915152,21.2866667 L183.847879,21.2866667 C186.281212,21.2866667 188.580606,21.2866667 189.766061,22.6733333 C190.475152,23.5030303 190.689697,24.7327273 190.421818,26.4321212 L190.421818,26.4321212 Z M188.865455,13.8036364 L175.38,13.8036364 C174.458182,13.8036364 173.673333,14.4745455 173.529697,15.3854545 L168.07697,49.9630303 C167.969091,50.6448485 168.496364,51.2618182 169.187273,51.2618182 L176.106061,51.2618182 C176.751515,51.2618182 177.301212,50.7921212 177.401212,50.1545455 L178.947879,40.3521212 C179.091515,39.4412121 179.876364,38.770303 180.798182,38.770303 L185.065455,38.770303 C193.947879,38.770303 199.073939,34.4715152 200.413939,25.9521212 C201.01697,22.2260606 200.438182,19.2981818 198.693333,17.2484848 C196.775758,14.9951515 193.37697,13.8036364 188.865455,13.8036364 L188.865455,13.8036364 Z" id="Fill-1" fill="#2790C3"></path>
                        <path d="M94.2418182,26.4321212 C93.5048485,31.2727273 89.8078788,31.2727273 86.2327273,31.2727273 L84.1981818,31.2727273 L85.6248485,22.2351515 C85.7115152,21.6890909 86.1824242,21.2866667 86.7351515,21.2866667 L87.6678788,21.2866667 C90.1018182,21.2866667 92.4012121,21.2866667 93.5860606,22.6733333 C94.2957576,23.5030303 94.510303,24.7327273 94.2418182,26.4321212 L94.2418182,26.4321212 Z M92.6860606,13.8036364 L79.2006061,13.8036364 C78.2787879,13.8036364 77.4939394,14.4745455 77.350303,15.3854545 L71.8969697,49.9630303 C71.789697,50.6448485 72.3169697,51.2618182 73.0072727,51.2618182 L79.4460606,51.2618182 C80.3678788,51.2618182 81.1533333,50.5909091 81.2969697,49.6806061 L82.7684848,40.3521212 C82.9115152,39.4412121 83.6969697,38.770303 84.6187879,38.770303 L88.8860606,38.770303 C97.7678788,38.770303 102.894545,34.4715152 104.234545,25.9521212 C104.837576,22.2260606 104.258788,19.2981818 102.513939,17.2484848 C100.595758,14.9951515 97.1969697,13.8036364 92.6860606,13.8036364 L92.6860606,13.8036364 Z" id="Fill-2" fill="#27346A"></path>
                        <path d="M123.992121,38.8454545 C123.368485,42.5351515 120.439394,45.0121212 116.703636,45.0121212 C114.830909,45.0121212 113.331515,44.409697 112.367879,43.2690909 C111.412727,42.1381818 111.053333,40.5272727 111.355758,38.7333333 C111.937576,35.0769697 114.913333,32.52 118.592121,32.52 C120.426061,32.52 121.914545,33.1284848 122.897576,34.2793939 C123.886667,35.4387879 124.275152,37.0606061 123.992121,38.8454545 L123.992121,38.8454545 Z M132.990909,26.2775758 L126.533939,26.2775758 C125.980606,26.2775758 125.509697,26.6793939 125.423636,27.2266667 L125.139394,29.0321212 L124.687879,28.3775758 C123.289697,26.3478788 120.173333,25.669697 117.061212,25.669697 C109.927273,25.669697 103.833333,31.0757576 102.647273,38.6581818 C102.029697,42.4406061 102.906061,46.0551515 105.050909,48.5781818 C107.021212,50.8963636 109.833333,51.8612121 113.183636,51.8612121 C118.933939,51.8612121 122.12303,48.1672727 122.12303,48.1672727 L121.834545,49.9618182 C121.726667,50.6442424 122.253939,51.2618182 122.944848,51.2618182 L128.76,51.2618182 C129.681818,51.2618182 130.466667,50.5915152 130.610303,49.6806061 L134.101212,27.5763636 C134.209091,26.8939394 133.681818,26.2775758 132.990909,26.2775758 L132.990909,26.2775758 Z" id="Fill-3" fill="#27346A"></path>
                        <path d="M220.171515,38.8454545 C219.547879,42.5351515 216.619394,45.0121212 212.883636,45.0121212 C211.010303,45.0121212 209.511515,44.409697 208.547273,43.2690909 C207.592121,42.1381818 207.232727,40.5272727 207.535758,38.7333333 C208.11697,35.0769697 211.092727,32.52 214.772121,32.52 C216.605455,32.52 218.094545,33.1284848 219.07697,34.2793939 C220.066061,35.4387879 220.454545,37.0606061 220.171515,38.8454545 L220.171515,38.8454545 Z M229.170303,26.2775758 L222.713333,26.2775758 C222.16,26.2775758 221.689091,26.6793939 221.60303,27.2266667 L221.318788,29.0321212 L220.867879,28.3775758 C219.469091,26.3478788 216.352727,25.669697 213.240606,25.669697 C206.107273,25.669697 200.012727,31.0757576 198.826667,38.6581818 C198.209697,42.4406061 199.086061,46.0551515 201.230303,48.5781818 C203.201212,50.8963636 206.012727,51.8612121 209.36303,51.8612121 C215.113333,51.8612121 218.302424,48.1672727 218.302424,48.1672727 L218.014545,49.9618182 C217.906061,50.6442424 218.433333,51.2618182 219.124848,51.2618182 L224.939394,51.2618182 C225.861212,51.2618182 226.646061,50.5915152 226.790303,49.6806061 L230.280606,27.5763636 C230.388485,26.8939394 229.861212,26.2775758 229.170303,26.2775758 L229.170303,26.2775758 Z" id="Fill-4" fill="#2790C3"></path>
                        <g id="Group-10">
                            <mask id="mask-2" fill="white">
                                <use xlink:href="#path-1"></use>
                            </mask>
                            <g id="Clip-6"></g>
                            <path d="M167.381818,26.2775758 L160.891515,26.2775758 C160.270909,26.2775758 159.690303,26.5854545 159.341818,27.0987879 L150.389091,40.2848485 L146.594545,27.6139394 C146.357576,26.8212121 145.627879,26.2775758 144.8,26.2775758 L138.42,26.2775758 C137.649697,26.2775758 137.107273,27.0351515 137.355758,27.7642424 L144.502424,48.7412121 L137.780606,58.2260606 C137.252727,58.970303 137.785455,60 138.697576,60 L145.181818,60 C145.796364,60 146.371515,59.6987879 146.721818,59.1933333 L168.306061,28.0424242 C168.822424,27.2969697 168.289091,26.2775758 167.381818,26.2775758" id="Fill-5" fill="#27346A" mask="url(#mask-2)"></path>
                            <path d="M236.781212,14.7533333 L231.246667,49.9630303 C231.139394,50.6454545 231.666667,51.2618182 232.35697,51.2618182 L237.923636,51.2618182 C238.845455,51.2618182 239.630303,50.5909091 239.773939,49.6806061 L245.230909,15.1030303 C245.338788,14.4206061 244.811515,13.8036364 244.120606,13.8036364 L237.891515,13.8036364 C237.338182,13.8036364 236.867273,14.2066667 236.781212,14.7533333" id="Fill-7" fill="#2790C3" mask="url(#mask-2)"></path>
                            <path d="M25.5466667,57.5484848 L27.3593939,46.0539394 L27.4763636,45.4169697 C27.5636364,44.8630303 27.8472727,44.3563636 28.2745455,43.9915152 C28.7018182,43.6266667 29.2466667,43.4254545 29.8084848,43.4254545 L31.2478788,43.4254545 C33.6472727,43.4254545 35.8515152,43.1690909 37.8,42.6636364 C39.8787879,42.1248485 41.7278788,41.2854545 43.2951515,40.1709091 C44.9569697,38.9890909 46.3527273,37.4612121 47.4442424,35.6309091 C48.5957576,33.7 49.4412121,31.3751515 49.9575758,28.7218182 C50.4139394,26.3787879 50.4993939,24.2812121 50.2127273,22.4866667 C49.9090909,20.5909091 49.1787879,18.9733333 48.0424242,17.6775758 C47.3533333,16.8927273 46.4715152,16.2127273 45.4218182,15.6563636 L45.3969697,15.6430303 L45.3963636,15.6127273 C45.7630303,13.2739394 45.7490909,11.3230303 45.3545455,9.64363636 C44.9581818,7.96060606 44.1557576,6.44606061 42.8993939,5.01454545 C40.2963636,2.04848485 35.5618182,0.544242424 28.8278788,0.544242424 L10.3339394,0.544242424 C9.71575758,0.544242424 9.11575758,0.765454545 8.64545455,1.16727273 C8.17515152,1.56909091 7.86363636,2.12727273 7.76666667,2.73818182 L0.0660606061,51.570303 C-0.00424242424,52.0157576 0.123636364,52.4684848 0.416969697,52.810303 C0.71030303,53.1539394 1.1369697,53.3509091 1.58787879,53.3509091 L13.0612121,53.3509091 L13.0509091,53.4054545 L12.2630303,58.4018182 C12.2024242,58.790303 12.3139394,59.1842424 12.5690909,59.4824242 C12.8242424,59.7812121 13.1957576,59.9533333 13.5884848,59.9533333 L23.2115152,59.9533333 C23.7515152,59.9533333 24.2745455,59.76 24.6848485,59.4090909 C25.0951515,59.0581818 25.3678788,58.5715152 25.4521212,58.0387879 L25.5466667,57.5484848" id="Fill-8" fill="#27346A" mask="url(#mask-2)"></path>
                            <path d="M18.9539394,15.6763636 C19.0757576,14.9024242 19.5721212,14.2690909 20.2406061,13.9484848 C20.5448485,13.8030303 20.8842424,13.7218182 21.24,13.7218182 L35.7363636,13.7218182 C37.4539394,13.7218182 39.0551515,13.8345455 40.5193939,14.070303 C40.9375758,14.1375758 41.3442424,14.2151515 41.74,14.3030303 C42.1357576,14.3909091 42.5193939,14.4884848 42.8909091,14.5975758 C43.0769697,14.6515152 43.2593939,14.7084848 43.4393939,14.7684848 C44.1581818,15.0072727 44.8272727,15.2884848 45.4430303,15.6145455 C46.1690909,10.9860606 45.4381818,7.83636364 42.9345455,4.98363636 C40.1781818,1.8430303 35.1987879,0.497575758 28.8278788,0.497575758 L10.3339394,0.497575758 C9.03212121,0.497575758 7.92363636,1.44484848 7.72060606,2.73090909 L0.02,51.5630303 C-0.132121212,52.5266667 0.612727273,53.3975758 1.58787879,53.3975758 L13.0048485,53.3975758 L18.9539394,15.6763636" id="Fill-9" fill="#27346A" mask="url(#mask-2)"></path>
                        </g>
                        <path d="M45.4430303,15.6145455 L45.4430303,15.6145455 C45.3878788,15.9678788 45.3266667,16.3272727 45.2539394,16.6975758 C42.8157576,29.2193939 34.4715152,33.5484848 23.8145455,33.5484848 L18.3878788,33.5484848 C17.0860606,33.5484848 15.9866667,34.4963636 15.7836364,35.7824242 L12.2169697,58.3951515 C12.0842424,59.2375758 12.7357576,60 13.5884848,60 L23.2121212,60 C24.3509091,60 25.3206061,59.1715152 25.4981818,58.0460606 L25.5927273,57.5569697 L27.4054545,46.0612121 L27.5224242,45.4260606 C27.7,44.3006061 28.669697,43.4721212 29.8084848,43.4721212 L31.2478788,43.4721212 C40.5709091,43.4721212 47.8709091,39.6842424 50.0042424,28.730303 C50.8951515,24.1533333 50.4345455,20.3327273 48.0775758,17.6466667 C47.3648485,16.8345455 46.4775758,16.1624242 45.4430303,15.6145455" id="Fill-11" fill="#2790C3"></path>
                        <path d="M42.8909091,14.5975758 C42.5193939,14.4884848 42.1357576,14.3909091 41.74,14.3030303 C41.3442424,14.2151515 40.9375758,14.1375758 40.5193939,14.070303 C39.0551515,13.8345455 37.4539394,13.7218182 35.7363636,13.7218182 L21.24,13.7218182 C20.8842424,13.7218182 20.5448485,13.8030303 20.2406061,13.9484848 C19.5721212,14.2690909 19.0757576,14.9024242 18.9539394,15.6763636 L15.8727273,35.2121212 L15.7836364,35.7824242 C15.9866667,34.4963636 17.0860606,33.5484848 18.3878788,33.5484848 L23.8145455,33.5484848 C34.4715152,33.5484848 42.8157576,29.2193939 45.2539394,16.6975758 C45.3266667,16.3272727 45.3878788,15.9678788 45.4430303,15.6145455 C44.8272727,15.2884848 44.1581818,15.0072727 43.4393939,14.7684848 C43.2593939,14.7084848 43.0769697,14.6515152 42.8909091,14.5975758" id="Fill-12" fill="#1F264F"></path>
                    </g>
                </g>
            </g>
        </svg>`
    }

    // 渲染按钮
    function renderButton(props){
        const borderColor = props?.borderColor || props?.backgroundColor || "#ffffff";
        const backgroundColor = props?.backgroundColor || "#ffffff";
        const button = document.createElement("button");
        button.style.boxSizing = "border-box";
        button.style.flex = "1";
        button.style.border = `2px solid ${borderColor}`;
        button.style.padding = "1rem";
        button.style.borderRadius = "0px";
        button.style.backgroundColor = backgroundColor;
        button.onclick = props?.onClick;
        button.innerHTML = props?.children || "";
        return button;
    }
    // 渲染内容
    function renderContent(node){
        if(node.innerHTML) return;
        const type = node.dataset.type;
        node.style.gap = "15px";
        node.style.display = "flex";
        node.style.flexWrap = "wrap";
        node.style.border = "none";
        node.style.padding = "0";
        node.innerHTML = "";
        const onClick =  window[type];
        merchants.forEach((item)=>{
            if(item.payment_name === "paypal"){
                node.appendChild(renderButton({ 
                    backgroundColor: "#ffc439", 
                    onClick:(e)=>{ 
                        localStorage.setItem("quick_payment_name", item.payment_name)
                        localStorage.setItem("quick_payment_method", item.payment_method)
                        onClick?.(e);
                    }, 
                    children: renderPaypalIcon() 
                }))
            }
            if(item.payment_name === "stripe"){
                node.appendChild(renderButton({ 
                    backgroundColor: "#635bff", 
                    onClick:(e)=>{ 
                        localStorage.setItem("quick_payment_name", item.payment_name)
                        localStorage.setItem("quick_payment_method", item.payment_method)
                        onClick?.(e) 
                    }, 
                    children: renderStripeIcon() 
                }))
            }
        })
    }
}();